import { Component, OnInit } from '@angular/core';
import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { EmailsService } from "../../_services/emails.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
  selector: 'app-email-type-list',
  templateUrl: './email-type-list.component.html',
  styleUrls: ['./email-type-list.component.css']
})
export class EmailTypeListComponent implements OnInit {

  returnUrl: string;
  userdetaild: string;
  emailList: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private emailsservice: EmailsService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    this.getAllEmailType();
  }

  getAllEmailType() {
    this.emailsservice.getAllEmailType()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.emailList = data.emailList;
          } else {
            this.toaster.showError('Emails', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Emails', error.error.ResponseMessage);
        });
  }

}
